import { useEffect, useRef, useState } from "preact/hooks";
import { api, type Mailbox } from "../api";

// Champ de destinataires avec suggestions : le dernier élément saisi (après la dernière
// virgule) est comparé aux correspondants connus.
export function RecipientInput({ value, onChange, label }: { value: string; onChange: (v: string) => void; label: string }) {
  const [suggestions, setSuggestions] = useState<Mailbox[]>([]);
  const [active, setActive] = useState(0);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const asked = useRef("");

  const lastToken = (v: string) => v.split(/[,;]/).pop()!.trim();

  useEffect(() => () => clearTimeout(timer.current), []);

  const input = (v: string) => {
    onChange(v);
    clearTimeout(timer.current);
    const token = lastToken(v);
    if (!token || token.includes("<")) { setSuggestions([]); return; }
    timer.current = setTimeout(() => {
      asked.current = token;
      api.contacts(token).then(({ contacts }) => {
        if (asked.current !== token) return; // une frappe plus récente a pris le relais
        setSuggestions(contacts);
        setActive(0);
      }).catch(() => setSuggestions([]));
    }, 150);
  };

  const choose = (m: Mailbox) => {
    const head = value.slice(0, Math.max(value.lastIndexOf(","), value.lastIndexOf(";")) + 1);
    const formatted = m.name ? `${m.name} <${m.address}>` : m.address;
    onChange(`${head ? `${head.trimEnd()} ` : ""}${formatted}, `);
    setSuggestions([]);
  };

  const key = (e: KeyboardEvent) => {
    if (suggestions.length === 0) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => (a + 1) % suggestions.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => (a - 1 + suggestions.length) % suggestions.length); }
    else if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); choose(suggestions[active]); }
    else if (e.key === "Escape") setSuggestions([]);
  };

  return (
    <span class="recipients">
      <input inputMode="email" value={value} autocapitalize="none" spellcheck={false} autocomplete="off" aria-label={label}
        role="combobox" aria-expanded={suggestions.length > 0} aria-autocomplete="list"
        onInput={(e) => input((e.target as HTMLInputElement).value)} onKeyDown={key}
        onBlur={() => setTimeout(() => setSuggestions([]), 150)} />
      {suggestions.length > 0 && (
        <div class="menu suggestions" role="listbox">
          {suggestions.map((m, i) => (
            <button role="option" aria-selected={i === active} class={i === active ? "active" : ""}
              onMouseDown={(e) => e.preventDefault()} onClick={() => choose(m)}>
              <span>{m.name ?? m.address}</span>
              {m.name && <span class="sub">{m.address}</span>}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
